import {observer} from 'mobx-react';
import FormSection from '../../../forms/FormSection';
import FormRow from '../../../forms/FormRow';
import FormColumn from '../../../forms/FormColumn';
import FormFieldBase from '../../../components/fields/FormFieldBase';
import {Box, MenuItem, TextField, Typography, useTheme} from '@mui/material';

function AllowanceSubsection({
                                 title,
                                 placeholder,
                                 kindOptions,
                                 selectedKind,
                                 onKindChange,
                                 KindPanel,
                                 subsectionForm,
                                 allowance,
                                 readOnly = false,
                             }) {
    const theme = useTheme();
    const style = styles(theme);

    return (
        <FormSection title={title}>
            <FormColumn>
                <FormRow>
                    <FormFieldBase>
                        <TextField
                            select
                            label="Tipo"
                            required
                            fullWidth
                            disabled={readOnly}
                            style={style.kindSelector}
                            value={selectedKind ?? ''}
                            onChange={(event) => onKindChange(event.target.value)}
                            sx={{
                                '& .MuiInputLabel-root, & .MuiInputLabel-shrink, & .MuiOutlinedInput-root, & .MuiInputBase-input': {
                                    fontSize: '.8rem',
                                },
                            }}
                        >
                            {kindOptions.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </FormFieldBase>
                </FormRow>
                {KindPanel && subsectionForm ? (
                    <KindPanel allowance={allowance} subsectionForm={subsectionForm} readOnly={readOnly}/>
                ) : (
                    <Box sx={style.placeholder}>
                        <Typography variant="body2">{placeholder}</Typography>
                    </Box>
                )}
            </FormColumn>
        </FormSection>
    );
}

export default observer(AllowanceSubsection);

const styles = (theme) => ({
    kindSelector: {
        backgroundColor: theme.brand.field,
        borderRadius: '5px',
    },
    placeholder: {
        padding: '0.5rem 0.25rem',
        color: theme.palette.text.secondary,
        fontStyle: 'italic',
    },
});
